import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { MultiChainProvider } from './contexts/MultiChainProvider';
import HomePage from './components/HomePage';
import ConnectPage from './components/ConnectPage';

function App() {
  return (
    <MultiChainProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/connect" element={<ConnectPage />} />
        </Routes>
      </Router>
    </MultiChainProvider>
  );
}

export default App;